import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
// Design tokens & base styles (must be imported BEFORE Vuetify so token
// CSS variables are available when Vuetify-themed components mount)
import './assets/styles/tokens.css'
import './assets/styles/base.css'
import './assets/styles/info-table.css'
import vuetify from './plugins/vuetify'
import router from './router'

// webfontloader 호출 제거 — Roboto 만 로드하던 레거시. 어드민은 Pretendard(tokens.css)로 통일.

createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')